import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { extendTheme, createBreakpoints } from '@hausgold/designsystem';
import { theme as theme$1 } from '@chakra-ui/react';
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

// Formwizard theme
// We use slightly different breakpoint values here, namely the `md` value is different.
var theme = extendTheme({
  colors: {
    red: {
      400: '#e04912'
    }
  },
  breakpoints: createBreakpoints({
    sm: '576px',
    md: '725px',
    lg: '992px',
    xl: '1200px'
  }),
  components: {
    Button: {
      variants: {
        primary: function primary() {
          return {
            color: 'white',
            borderRadius: 'circle',
            borderColor: 'red.400',
            bg: 'red.400',
            px: 10,
            py: 3,
            boxShadow: 'none'
          };
        },
        muted: function muted() {
          return {
            bg: 'white',
            color: 'gray.400',
            borderColor: '#bfbec8',
            borderRadius: 'circle',
            px: 14,
            py: 6,
            boxShadow: 'none',
            _hover: {
              color: 'gray.400'
            }
          };
        }
      }
    },
    Slider: _objectSpread(_objectSpread({}, theme$1.components.Slider), {}, {
      baseStyle: function baseStyle(props) {
        return _objectSpread(_objectSpread({}, theme$1.components.Slider.baseStyle(props)), {}, {
          thumb: _objectSpread(_objectSpread({}, theme$1.components.Slider.baseStyle(props).thumb), {}, {
            bg: 'blue.400'
          }),
          track: _objectSpread(_objectSpread({}, theme$1.components.Slider.baseStyle(props).track), {}, {
            borderRadius: '50px'
          }),
          filledTrack: _objectSpread(_objectSpread({}, theme$1.components.Slider.baseStyle(props).filledTrack), {}, {
            bg: 'blue.400'
          })
        });
      },
      sizes: _objectSpread(_objectSpread({}, theme$1.components.Slider.sizes), {}, {
        lg: function lg() {
          return {
            track: {
              h: '8px'
            }
          };
        }
      })
    }),
    Tooltip: _objectSpread({}, theme$1.components.Tooltip),
    Radio: {
      baseStyle: {
        label: {
          color: 'gray.500'
        }
      }
    }
  }
});
export { theme as default };